const image = "Avatar-module_image_1JRP-atM";
const initials = "Avatar-module_initials_mBtUleCQ";
const styles = {
  image,
  initials
};
export {
  styles as default,
  image,
  initials
};
